import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},[_c('client-only',[_c(VCarousel,{attrs:{"height":"100%","hide-delimiters":"","hide-delimiter-background":""}},_vm._l((_vm.subpictures),function(subpicture){return _c(VCarouselItem,{key:subpicture.identifier},[_c('DeclarationImage',{attrs:{"subpicture":subpicture,"multiple":""}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }